import { Route, Redirect, RouteProps, useLocation } from 'react-router-dom';
import AppFrame from 'components/AppFrame';
import { AppToaster } from 'components/AppToaster';
import { useAuth } from 'hooks/useAuth';

import AppProviders from './Providers';

interface Props {
  accessRoute?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.ComponentType<any>;
}

export function PrivateRoute({
  accessRoute = true,
  component: Component,
  ...routeProps
}: Omit<RouteProps, 'component'> & Props) {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const { pathname } = location;

  function renderComponent(routerProps: RouteProps) {
    if (accessRoute && isAuthenticated) {
      return <Component {...routerProps} />;
    }

    return <Redirect to="/" />;
  }

  if (!isAuthenticated) {
    window.location.replace(`/signin?continue=${pathname}`);
    return <></>;
  }

  return (
    <AppProviders>
      <AppFrame>
        <Route {...routeProps} render={renderComponent} />
      </AppFrame>
    </AppProviders>
  );
}

/**
 * Authenticated route WITHOUT the AppFrame sidebar layout.
 * Use for fullscreen experiences (e.g., onboarding wizard) that need auth but no navigation chrome.
 */
export function PrivateRouteNoFrame({
  accessRoute = true,
  component: Component,
  ...routeProps
}: Omit<RouteProps, 'component'> & Props) {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const { pathname } = location;

  function renderComponent(routerProps: RouteProps) {
    if (accessRoute && isAuthenticated) {
      return <Component {...routerProps} />;
    }

    return <Redirect to="/" />;
  }

  if (!isAuthenticated) {
    window.location.replace(`/signin?continue=${pathname}`);
    return <></>;
  }

  return (
    <>
      <AppProviders>
        <Route {...routeProps} render={renderComponent} />
      </AppProviders>
      <AppToaster />
    </>
  );
}

export default PrivateRoute;
